export default __webpack_public_path__ + "static/fun-icon4-4481d43ba1b0919155585f2c1ec5b7ba.png";